import { render, staticRenderFns } from "./DarkMood.vue?vue&type=template&id=f5fd0bee&"
import script from "./DarkMood.vue?vue&type=script&lang=js&"
export * from "./DarkMood.vue?vue&type=script&lang=js&"
import style0 from "./DarkMood.vue?vue&type=style&index=0&id=f5fd0bee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports